import { Check, X } from 'lucide-react';

const differentiators = [
  {
    feature: 'Built for Commodities',
    tradenexus: 'Designed specifically for CFTC position limit compliance',
    oldWay: 'Generic tools adapted for commodities',
  },
  {
    feature: 'Real-Time Monitoring',
    tradenexus: 'Live position tracking as trades execute',
    oldWay: 'End-of-day reports only',
  },
  {
    feature: 'Aggregation Done Right',
    tradenexus: 'Automatic multi-account aggregation per CFTC rules',
    oldWay: 'Manual spreadsheet consolidation',
  },
  {
    feature: 'Audit-Ready Always',
    tradenexus: 'Complete compliance trail at your fingertips',
    oldWay: 'Scrambling to reconstruct history',
  },
  {
    feature: 'Enterprise Security',
    tradenexus: 'SOC 2 compliant with bank-level encryption',
    oldWay: 'Emailed spreadsheets with sensitive data',
  },
  {
    feature: 'Expert Support',
    tradenexus: 'Dedicated compliance specialists on call',
    oldWay: 'Generic help desk with no industry knowledge',
  },
];

export function WhyChooseUsSection() {
  return (
    <section id="why-us" className="relative py-20 md:py-28 bg-slate-50">
      <div className="container relative">
        {/* Section Header */}
        <div className="mx-auto max-w-2xl text-center mb-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-slate-100 border border-slate-200 px-4 py-1.5 text-sm mb-6">
            <span className="text-slate-700 font-medium">Why PositionIQ</span>
          </div>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4 text-slate-900">
            Why Choose{' '}
            <span className="text-purple-600">
              PositionIQ
            </span>
            ?
          </h2>
          <p className="text-lg text-slate-600">
            See how we compare to traditional compliance approaches.
          </p>
        </div>

        {/* Comparison Table - Desktop */}
        <div className="mx-auto max-w-4xl hidden md:block">
          {/* Header Row */}
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div className="text-sm font-medium text-slate-500 px-4">Feature</div>
            <div className="text-sm font-medium text-center">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-600 text-white">
                <Check className="h-4 w-4" />
                PositionIQ
              </span>
            </div>
            <div className="text-sm font-medium text-center">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-100 text-red-700 border border-red-200">
                <X className="h-4 w-4" />
                The Old Way
              </span>
            </div>
          </div>

          {/* Comparison Rows */}
          <div className="space-y-3">
            {differentiators.map((item) => (
              <div
                key={item.feature}
                className="grid grid-cols-3 gap-4 p-4 rounded-2xl bg-white border border-slate-200 hover:shadow-md transition-shadow"
              >
                <div className="font-medium text-slate-900">{item.feature}</div>
                <div className="text-sm text-center">
                  <div className="flex items-start justify-center gap-2">
                    <div className="p-1 rounded-full bg-emerald-100">
                      <Check className="h-3 w-3 text-emerald-600" />
                    </div>
                    <span className="text-slate-600">{item.tradenexus}</span>
                  </div>
                </div>
                <div className="text-sm text-center">
                  <div className="flex items-start justify-center gap-2">
                    <div className="p-1 rounded-full bg-red-100">
                      <X className="h-3 w-3 text-red-500" />
                    </div>
                    <span className="text-slate-500">{item.oldWay}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile-Friendly Cards */}
        <div className="md:hidden space-y-4">
          {differentiators.map((item) => (
            <div key={item.feature} className="rounded-2xl bg-white border border-slate-200 p-5 shadow-sm">
              <h3 className="font-semibold mb-3 text-slate-900">{item.feature}</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-2 p-3 rounded-xl bg-emerald-50 border border-emerald-100">
                  <div className="p-1 rounded-full bg-emerald-500">
                    <Check className="h-3 w-3 text-white" />
                  </div>
                  <span className="text-slate-700">{item.tradenexus}</span>
                </div>
                <div className="flex items-start gap-2 p-3 rounded-xl bg-red-50 border border-red-100">
                  <div className="p-1 rounded-full bg-red-500">
                    <X className="h-3 w-3 text-white" />
                  </div>
                  <span className="text-slate-500 line-through">{item.oldWay}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
